import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function ImageUpload(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M13 7a4 4 0 118 0 4 4 0 01-8 0zm-2 0H6a2 2 0 00-2 2v9a2 2 0 002 2h.485l3.393-4.75a3 3 0 014.46-.476L17 17.194V13a6 6 0 01-6-6zm4 15H6a4 4 0 01-4-4V9a4 4 0 014-4h5.341A6 6 0 1119 12.659V18a4 4 0 01-4 4zm-3.494-5.588L8.943 20H15c.566 0 1.076-.235 1.44-.612l-3.448-3.134a1 1 0 00-1.486.158zM17 4.25a.75.75 0 01.75.75v1.25H19a.75.75 0 010 1.5h-1.25V9a.75.75 0 01-1.5 0V7.75H15a.75.75 0 010-1.5h1.25V5a.75.75 0 01.75-.75zM7.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    clipRule: "evenodd"
  }));
}

export default ImageUpload;